module.exports = __webpack_public_path__ + "static/media/household-goods.425f5797.svg";